import React, { Component } from "react";
import { connect } from "react-redux";
import MessageRenderer from "../common/components/MessageRenderer";
import { requestLogout, requestCheckAuthorized } from "../authentication/actions/authenticationActions";
import UsernameAndLogout from "./UsernameAndLogout";

const timIdeasLogo = process.env.IS_IN_WEBPACK ? require("../../images/tim-logo-header.png") : "";

export class AppComponent extends Component {
    constructor(props) {
        super(props);
    }

    componentWillMount() {
        this.props.checkAuthorized();
    }

    render() {
        return (
            <div style={{minWidth: 890}} className="pure-form pure-form-aligned">

                <header style={{backgroundColor: "#28313E", padding: 10}}>
                    <img src={timIdeasLogo} style={{width: 128, height: 46}}/>
                    {
                        this.props.authenticatedUser ?  <UsernameAndLogout onLogout={this.props.logout}
                                                                           username={this.props.authenticatedUser.username} />
                                                     : null

                   }
                </header>

                <div>
                    <MessageRenderer {...this.props.messages} position="static"/>

                    {this.props.children}
                </div>
            </div>
        );
    }
}

AppComponent.propTypes = {
    authenticatedUser: React.PropTypes.object,
    checkAuthorized: React.PropTypes.func.isRequired
};

const mapStateToProps = (state) => ({
    authenticatedUser: state.authentication.authenticatedUser
});

const mapDispatchToProps = (dispatch, ownProps) => ({
    checkAuthorized: () => dispatch(requestCheckAuthorized()),
    logout: () => dispatch(requestLogout())
});

export default connect(mapStateToProps, mapDispatchToProps)(AppComponent);



/** WEBPACK FOOTER **
 ** ./src/main/javascript/components/App.js
 **/